<template>
  <div class="bg-white p-5">
    <div class="bg-gray-100 rounded p-2.5">
      <div class="text-xs text-gray-400">
        下载导入模板，根据模板提示完善内容
      </div>
      <el-button
        icon="download"
        size="small"
        class="mt-1"
        plain
        @click="onDownLoad()"
        >下载模板</el-button
      >
    </div>
    <div class="bg-gray-100 rounded p-2.5 mt-3">
      <div class="text-xs text-gray-400">上传完善好的表格文件</div>
      <div
        class="bg-white py-10 flex flex-col items-center justify-center mt-2"
      >
        <el-image
          :src="require('@/assets/images/excel.png')"
          class="w-20 h-20"
        />
        <el-upload
          :show-file-list="false"
          :auto-upload="false"
          multiple
          :on-change="onChangeFile"
        >
          <el-button
            dashed
            plan
            icon="plus"
            style="
              border-color: var(--el-color-primary);
              color: var(--el-color-primary);
            "
            class="!text-xs hover:!text-green-600 hover:!border-green-600 mt-4"
            >上传文件
          </el-button>
        </el-upload>
        <text class="text-xs text-gray-400 mt-4">
          支持xls、xlsx文件，大小不超过300MB
        </text>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  meeting_hotelArrange_room_download,
  meeting_hotelArrange_room_import,
} from "@/http/meeting";

export default {
  props: {
    room_type: Object,
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {});

    const onDownLoad = () => {
      meeting_hotelArrange_room_download()
        .then((res) => {
          if (res.status == 200) {
            let fileName = decodeURI(
              res.headers["content-disposition"].split("=")[1],
            );

            //通过后台返回 的word文件流设置文件名并下载
            var blob = new Blob([res.data], {
              type: res.data.type,
            });
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          }
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    let handleFile = false;
    const onChangeFile = (file) => {
      if (!handleFile) {
        handleFile = true;
        ElMessageBox.confirm(
          `您确定<strong style='color:var(--el-color-warning)'>导入</strong><strong style='color:var(--el-color-primary)'>房间</strong>吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
            type: "warning",
            cancelButtonClass: "is-plain",
          },
        )
          .then(() => {
            const formData = new FormData();

            formData.append("meeting_id", props.room_type.meeting_id);
            formData.append(
              "meeting_hotel_arrange_id",
              props.room_type.meeting_hotel_arrange_id,
            );
            formData.append(
              "meeting_hotel_arrange_room_type_id",
              props.room_type.id,
            );
            formData.append("hotel_id", props.room_type.hotel_id);
            formData.append(
              "hotel_room_type_id",
              props.room_type.hotel_room_type_id,
            );
            formData.append("file", file.raw);

            meeting_hotelArrange_room_import(formData)
              .then((res) => {
                handleFile = false;
                ElMessageBox.alert(res.data.data?.msg, "导入结果", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    emit("close", true);
                  },
                });
              })
              .catch(() => {
                handleFile = false;
              });
          })
          .catch(() => {
            handleFile = false;
          });
      }
    };

    return { state, onDownLoad, onChangeFile };
  },
};
</script>
<style scoped></style>
